import React, { useEffect, useState } from 'react';

const fmt = valor =>
  Number(valor || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

function dataHoraBR(valor) {
  if (!valor) return '—';
  const data = new Date(valor);
  return Number.isNaN(data.getTime())
    ? '—'
    : data.toLocaleString('pt-BR');
}

function nomeEvento(evento) {
  const nomes = {
    criacao: 'Oportunidade criada',
    mudanca_etapa: 'Etapa alterada',
    atualizacao: 'Oportunidade atualizada',
    email_vinculado: 'E-mail vinculado',
  };

  return nomes[evento] || evento || 'Registro';
}

export default function CrmOportunidadeDetalhe({
  oportunidadeId,
  crmFetch,
  onClose,
}) {
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    let ativo = true;

    async function carregar() {
      setCarregando(true);
      setErro('');

      try {
        const resultado = await crmFetch(
          `/api/crm/oportunidades/${oportunidadeId}`
        );

        if (ativo) setDados(resultado);
      } catch (e) {
        if (ativo) setErro(e.message);
      } finally {
        if (ativo) setCarregando(false);
      }
    }

    carregar();

    return () => {
      ativo = false;
    };
  }, [oportunidadeId, crmFetch]);

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: 980, width: '95%' }}>
        <div
          className="modal-head"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 20px',
            borderBottom: '1px solid var(--border)',
          }}
        >
          <span className="modal-title">
            {dados?.titulo || 'Detalhes da oportunidade'}
          </span>
          <button
            className="modal-close"
            onClick={onClose}
            style={{
              border: 0,
              background: 'transparent',
              fontSize: 24,
              cursor: 'pointer',
            }}
          >
            ×
          </button>
        </div>

        <div className="modal-body">
          {carregando && <div>Carregando oportunidade...</div>}

          {erro && (
            <div style={{ color: 'var(--danger)', padding: 12 }}>
              {erro}
            </div>
          )}

          {dados && (
            <>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns:
                    'repeat(auto-fit, minmax(180px, 1fr))',
                  gap: 12,
                  marginBottom: 22,
                }}
              >
                <div className="kpi-card">
                  <div className="kpi-label">Empresa</div>
                  <div style={{ fontWeight: 700, marginTop: 6 }}>
                    {dados.empresa_nome_fantasia ||
                      dados.empresa_razao_social}
                  </div>
                </div>

                <div className="kpi-card">
                  <div className="kpi-label">Etapa</div>
                  <div style={{ marginTop: 6 }}>
                    <span
                      className="status"
                      style={{
                        background: dados.etapa_cor,
                        color: '#fff',
                      }}
                    >
                      {dados.etapa_nome}
                    </span>
                  </div>
                </div>

                <div className="kpi-card">
                  <div className="kpi-label">Valor estimado</div>
                  <div style={{ fontWeight: 700, marginTop: 6 }}>
                    {fmt(dados.valor_estimado)}
                  </div>
                </div>

                <div className="kpi-card">
                  <div className="kpi-label">Prioridade</div>
                  <div style={{ fontWeight: 700, marginTop: 6 }}>
                    {dados.prioridade || '—'}
                  </div>
                </div>
              </div>

              {dados.descricao && (
                <div style={{ marginBottom: 22 }}>
                  <div className="kpi-label">Descrição</div>
                  <div
                    style={{
                      marginTop: 6,
                      padding: 12,
                      background: 'var(--surface2)',
                      borderRadius: 9,
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {dados.descricao}
                  </div>
                </div>
              )}

              <div className="card-title" style={{ marginBottom: 12 }}>
                Linha do tempo
              </div>

              {!dados.atividades?.length && !dados.historico?.length && (
                <div style={{ color: 'var(--muted)', padding: 16 }}>
                  Nenhum registro encontrado nesta oportunidade.
                </div>
              )}

              <div style={{ display: 'grid', gap: 12 }}>
                {(dados.atividades || []).map(atividade => (
                  <div
                    key={`atividade-${atividade.id}`}
                    style={{
                      border: '1px solid var(--border)',
                      borderLeft: atividade.email_id
                        ? '4px solid #2563EB'
                        : '4px solid #64748B',
                      borderRadius: 10,
                      padding: 14,
                      background: 'var(--surface)',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 12,
                        flexWrap: 'wrap',
                      }}
                    >
                      <div>
                        <strong>
                          {atividade.email_id ? 'E-mail: ' : ''}
                          {atividade.email_assunto || atividade.titulo}
                        </strong>
                        <div
                          style={{
                            fontSize: 11,
                            color: 'var(--muted)',
                            marginTop: 4,
                          }}
                        >
                          {atividade.email_id
                            ? `${atividade.email_remetente_nome ||
                                atividade.email_remetente_email ||
                                'Remetente não identificado'} · ${dataHoraBR(
                                atividade.email_recebido_em ||
                                  atividade.concluida_em
                              )}`
                            : `${atividade.tipo} · ${dataHoraBR(
                                atividade.agendada_para ||
                                  atividade.concluida_em ||
                                  atividade.criado_em
                              )}`}
                        </div>
                      </div>

                      <span className="status">
                        {atividade.status}
                      </span>
                    </div>

                    {(atividade.email_resumo || atividade.descricao) && (
                      <div
                        style={{
                          marginTop: 12,
                          color: 'var(--text)',
                          whiteSpace: 'pre-wrap',
                          lineHeight: 1.5,
                        }}
                      >
                        {atividade.email_resumo || atividade.descricao}
                      </div>
                    )}

                    {atividade.email_id && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 10,
                          marginTop: 12,
                          flexWrap: 'wrap',
                        }}
                      >
                        {atividade.email_tem_anexos && (
                          <span style={{ fontSize: 11 }}>
                            📎 Possui anexo
                          </span>
                        )}

                        {atividade.email_web_link && (
                          <a
                            className="btn btn-sm btn-primary"
                            href={atividade.email_web_link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Abrir no Outlook
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                ))}

                {(dados.historico || [])
                  .filter(item => item.evento !== 'email_vinculado')
                  .map(item => (
                    <div
                      key={`historico-${item.id}`}
                      style={{
                        border: '1px solid var(--border)',
                        borderLeft: '4px solid #94A3B8',
                        borderRadius: 10,
                        padding: 14,
                        background: 'var(--surface)',
                      }}
                    >
                      <strong>{nomeEvento(item.evento)}</strong>
                      <div
                        style={{
                          fontSize: 11,
                          color: 'var(--muted)',
                          marginTop: 4,
                        }}
                      >
                        {dataHoraBR(item.criado_em)}
                      </div>
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
